import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { observer } from 'mobx-react-lite'
import { ActiveColorsIndicator } from 'common/Prose/components/ActiveColorsIndicator/ActiveColorsIndicator'
import { computed } from 'mobx'
import { AlmanacEditorStateContext } from 'stores/EditorState'
import { useContext } from 'react'
import Styles from './DoubleActionButtons/DoubleActionButtons.module.scss'
import { SimpleDropdown } from './SimpleDropdown/SimpleDropdown'
import { TextColorPicker } from 'common/Prose/components/TextColorPicker/TextColorPicker'
import { IconName, ToolbarIcon } from 'common/Prose/Toolbar/ToolbarIcon'

export const InlineTextColorButton = observer(() => {
  const view = useEditorView()
  const editorState = useContext(AlmanacEditorStateContext)
  const activeColors = computed(() => editorState?.activeColors && Array.from(editorState.activeColors)).get() || []

  return (
    <SimpleDropdown hasChevron={false} tooltip={{ label: 'Text color' }} placement="bottom">
      <div className={Styles.trigger}>
        <ToolbarIcon name={IconName.TextColor} />
        <ActiveColorsIndicator colors={activeColors} className={Styles.activeTextColorsOverride} />
      </div>
      <TextColorPicker view={view} activeColors={activeColors} />
    </SimpleDropdown>
  )
})
